import { createFileRoute } from '@tanstack/react-router';
import { AuthScreen } from '../components/auth-screen';
import { NewPasswordForm, TokenSearch } from '../components/new-password-form';

/**
 * Where an admin invitation lands. Only invitations link here; the API words
 * an ADMIN's reset aimed at this page as an invitation, so the forgot-password
 * flow uses /reset-password instead.
 */
export const Route = createFileRoute('/set-password')({
  validateSearch: (search) => TokenSearch.parse(search),
  component: SetPasswordPage,
});

function SetPasswordPage() {
  const { token } = Route.useSearch();
  return (
    <AuthScreen
      title="Welcome to the back office"
      description="You have been invited to MyHome+ as an admin. Choose a password to finish setting up your account."
    >
      <NewPasswordForm token={token} submitLabel="Set password" onDone="password-set" />
    </AuthScreen>
  );
}
